const modalCreateNote = {
  header: 'Notiz erstellen',
  btnCancel: 'Stornieren',
  btnOk: 'OK',
};

export default modalCreateNote;
